import { ACTIVITIES_BASE_HEIGHT_LARGE } from 'global/constants';
import { COLOURS } from './response.constants';
import type { AnswerFragment } from '../../present/activity-answers.graphql.generated';
import { isRichtextValueEmpty } from '../shared/logic/get-richtext-value';
import { getRichtextAnswer } from '../shared/logic/get-richtext-answer';
import type { Pluck } from 'lib/gql/pluck';

export function getFieldHeight(size: number, baseHeight?: number | null) {
  return size * (baseHeight || ACTIVITIES_BASE_HEIGHT_LARGE);
}

export function getBackgroundColour(baseColour: string) {
  return COLOURS.find(c => c.base === baseColour)?.colour1;
}

export function getBorderColour(baseColour: string) {
  return COLOURS.find(c => c.base === baseColour)?.colour2;
}

export function getActiveStudentAnswerCount(
  answers: {
    uuid: string;
    studentId: number | null;
    answer: Pluck<AnswerFragment, 'answer'> | null;
  }[]
) {
  const activeStudentsWithResponses = new Set();

  answers.forEach(answer => {
    if (!isRichtextValueEmpty(getRichtextAnswer(answer))) {
      activeStudentsWithResponses.add(answer.studentId);
    }
  });

  return activeStudentsWithResponses.size;
}
